import React, { useContext } from 'react'
import Font from '@cred/react-font'
import PropType from 'prop-types'
import { fireGtmEvent } from 'utils/gtm'
import CtaButton from 'components/cta-button'
import WidgetContext from 'components/widget-context'
import PoweredBy from 'components/powered-by'
import { AdvertiserDisclosure } from 'components/advertiser-disclosure'
import styles from './styles.scss'

const onClick = widgetContext => () => {
    fireGtmEvent('ctaClick', widgetContext)
  },
  CopyOnly = ({ href, theme, title, body, ctaText, nmls }) => {
    const widgetContext = useContext(WidgetContext),
      isFoxTheme = theme === 'fox'

    return (
      <div className={styles.container}>
        { isFoxTheme && <AdvertiserDisclosure /> }
        <div className={styles.widget}>
          <div className={styles.copy}>
            <Font type="heading" weight="bold" className={`${styles.title} mb-8`}>{title}</Font>
            <Font className={`${styles.body} mb-16 mb-sm-0`}>{body}</Font>
          </div>
          <div className={styles.cta}>
            <CtaButton
              href={href}
              onClick={onClick(widgetContext)}
              blank
              fullWidth
            >
              {ctaText}
            </CtaButton>
            <PoweredBy className={`mt-8 mt-sm-16 ${styles.poweredBy}`} />
            {nmls && <Font element="div" className={styles.cred}>Credible Operations, Inc. NMLS # 1681276</Font>}
          </div>
        </div>
      </div>
    )
  }

CopyOnly.propTypes = {
  href: PropType.string.isRequired,
  title: PropType.string.isRequired,
  theme: PropType.string.isRequired,
  body: PropType.string.isRequired,
  ctaText: PropType.string.isRequired,
  nmls: PropType.bool,
}

CopyOnly.defaultProps = {
  nmls: false,
}

export { CopyOnly, onClick }

export default CopyOnly
